export default __webpack_public_path__ + "static/media/Pokedex.87abd375.PNG";